<script>
import resources from './resources'

export default {
  name: 'professional-consultations-made',

  mixins: [resources]
}
</script>

<template lang="pug">
  .row
    .col-xs-12
      .infos
        .col-xs-6.col-xs-offset-3.col-sm-2.col-sm-offset-0.col-md-offset-0.col-lg-offset-0
          img.img-circle(:src='schedule.patient.avatar')
        .col-xs-12.col-sm-7.border-right
          .row
            .col-xs-12.col-sm-10
              label.light-red Paciente
              h2.medium-gra {{ schedule.patient.name }}
            .col-xs-12.col-sm-2
              label.light-red Idade
              h3.medium-gra {{ schedule.patient.age }}
            .clearfix
            .col-xs-12.col-sm-6
              label.light-red Convênio
              h4.medium-gra {{ schedule.covenant }}
            .col-xs-12.col-sm-6
              label.light-red Empresa
              h4.medium-gra Não informada
        .col-xs-12.col-sm-3
          label.light-red Pontualidade
          .time-rating
            span.icon.active 
            span.icon.active 
            span.icon.active 
            span.icon.active 
            span.icon.active 
          label.light-red Comportamento
          .behaviour-rating
            span.icon.active 
            span.icon.active 
            span.icon.active 
            span.icon.active 
            span.icon 
      .clearfix
      .border-top
        .col-xs-12.col-sm-9
          label.light-red Profissional
          h3.medium-gra {{ professionalCurrent.name }}
        .col-xs-12.col-sm-3
          label.light-red CRM
          h3.medium-gra {{ professionalCurrent.document }}-{{ professionalCurrent.state }}
        .col-xs-12.col-sm-9
          label.light-red Especialidade
          h4.medium-gra {{ schedule.speciality }}
        .col-xs-12.col-sm-3
          label.light-red Hora Marcada
          h4.medium-gra {{ schedule.time }}
      .clearfix
      .border-top.col-xs-12
        label.light-red Históricos de Consultas Realizadas
        .table.col-xs-12
          .row.hidden-xs.hidden-sm
            .col-xs-12.col-sm-1.col-title.text-center Data
            .col-xs-12.col-sm-1.col-title.text-center Hora
            .col-xs-12.col-sm-3.col-title Profissional
            .col-xs-12.col-sm-3.col-title Especialidade
            .col-xs-12.col-sm-4.col-title Status Agenda
            //-.col-xs-12.col-sm-2.col-title.text-center Receituário
          .order-by.hidden-md.hidden-lg
            span
              select#ordenar-por(name='Ordenar por')
                option(value='Data') Data
                option(value='Hora') Hora
                option(value='Especialidade') Especialidade
                option(value='Profissional') Profissional
                option(value='Status Agenda') Status Agenda
                option(value='Receituário') Receituário
          ul.row(v-for="schedule in schedules", :key="schedule.id", style="height: auto")
            li
              .col-xs-12.col-sm-1.text-center
                small.grey
                  br
                | {{ schedule.date }}
              .col-xs-12.col-sm-1.text-center
                small.grey
                  br
                | {{ schedule.time }}
              .col-xs-12.col-sm-3
                small.grey
                  br
                | {{ schedule.professional }}
              .col-xs-12.col-sm-3
                small.grey
                  br
                | {{ schedule.speciality }}
              .col-xs-12.col-sm-4
                small.grey
                  br
                | {{ schedule.status }}
              //-.col-xs-12.col-sm-2.text-center
                small.grey
                  br
                span.icon.action &#xE921;
              .clearfix
      .clearfix
      .col-xs-12
        .buttons-wrapper
          button.btn.find-filled(@click.prevent="receituarioMake", data-dismiss="modal", :disabled='true')
            span.icon 
            |Receituário
          button.btn.find-filled(@click.prevent="atestadoMake", data-dismiss="modal", :disabled='true')
            span.icon 
            |Atestado Médico
          button.btn.find-filled(@click.prevent="avaliarMake", data-dismiss="modal")
            span.icon 
            |Avaliar
          button.btn.find-filled(@click.prevent="encaminharMake", data-dismiss="modal", :disabled='true')
            span.icon 
            |Encaminhar
          button.btn.cancel-filled.hidden-sm.hidden-md.hidden-lg(data-dismiss='modal')
            span.icon 
            | Fechar
</template>



// WEBPACK FOOTER //
// src/app/professional/dashboard/company/gadget/components/active-agenda/components/consultations-made/appointment-details.vue